import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { renderFullDate } from '../../../../../utils/time'
import { translation } from '../../../../../utils/helpers'
import GeneralNotesModal from '../../../../../shared/modals/GeneralNotesModal'
import { triggerPopup } from '../../../../../actions/backdrop'
import { deleteNote } from '../../../../../actions/generalnotes'
import { getOccurrenceNotes } from '../../../../../actions/tasks'
import Confirm from '../../../../../shared/components/Confirm'
import Portal from '../../../../../shared/components/Portal'

import './index.scss'
import Panel from '../../../../../shared/elements/panel'
import Button from '../../../../../shared/elements/button'

class Comments extends Component {
  constructor (props) {
    super(props)
    this.state = {
      notes: [],
      note: {
        modal: false,
        data: {}
      },
      confirmDelete: {
        open: false,
        NoteId: 0
      }
    }

    this.getOccurrenceNotes = this.getOccurrenceNotes.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.showNoteModal = this.showNoteModal.bind(this)
    this.onNoteSuccess = this.onNoteSuccess.bind(this)
    this.onPortalClose = this.onPortalClose.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
  }

  componentDidMount () {
    this.getOccurrenceNotes(this.props.OccurrenceId)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.OccurrenceId !== this.props.OccurrenceId) {
      this.getOccurrenceNotes(nextProps.OccurrenceId)
    }
  }

  getOccurrenceNotes (occurrenceId) {
    this.props.getOccurrenceNotes(occurrenceId).then(res => {
      this.setState({
        notes: res.data
      })
    })
  }

  showNoteModal (note) {
    this.props.triggerPopup(!this.state.note.modal)
    this.setState({
      note: {
        data: note,
        modal: !this.state.note.modal
      }
    })
  }

  onNoteSuccess (res) {
    this.setState({
      notes: res
    })
  }

  renderContent () {
    const newComment = () => {
      this.props.triggerPopup(true)
      this.setState({
        note: {
          data: {
            Note: '',
            OtherTaskOccurrenceId: this.props.OccurrenceId
          },
          modal: true
        }
      })
    }

    const deleteNote = (item) => {
      this.setState({
        confirmDelete: {
          open: true,
          NoteId: item.Id
        }
      })
    }

    // Comments
    const renderComment = (item, key) => {
      let editIcon = <div className='hint--top' aria-label={translation('13357')}><img src='/images/icons/edit_16.png' onClick={() => this.showNoteModal(item)} /></div>
      let deleteIcon = <div className='hint--top' aria-label={translation('2156')}><img src='/images/icons/Delete_16.png' onClick={() => deleteNote(item)} /></div>

      return (
        <div key={key} className='note'>
          <div className='heading'>
            <span>{item.CreatedByName}: {renderFullDate(item.CreatedDate)}</span>
            <div className='actions'>
              {item.IsMine === true && editIcon}
              {item.IsMine === true && deleteIcon}
            </div>
          </div>
          <div>{item.Note}</div>
        </div>
      )
    }
    // Return
    return (
      <div>
        <div className='notes'>
          {this.state.notes.map(renderComment)}
        </div>
        <Button size='l' style='link' onClick={newComment} labelText={translation('15359')} />
      </div>
    )
  }

  render () {
    return (
      <Panel title={`${translation('14834')} (${this.state.notes.length})`}>
        {this.renderContent()}
        <GeneralNotesModal
          show={this.state.note.modal}
          onClose={this.showNoteModal}
          note={this.state.note.data}
          onSuccess={this.onNoteSuccess} />
        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose}>
            <Confirm confirm={this.onConfirm} notConfirm={this.onPortalClose} />
          </Portal>
        )}
      </Panel>
    )
  }

  onConfirm () {
    this.onPortalClose()
    this.props.deleteNote(this.state.confirmDelete.NoteId).then((res) => {
      this.setState({
        notes: res.data
      })
      // Toastr
      // window.toastr.success(translation('1895'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('13441'), translation('216'))
    })
  }

  onPortalClose () {
    this.setState({
      confirmDelete: {
        ...this.state.confirmDelete,
        open: false,
        NoteId: 0
      }
    })
  }

}

Comments.contextTypes = {
  router: PropTypes.object.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  triggerPopup,
  getOccurrenceNotes,
  deleteNote
})(Comments)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyTasks/Task/Comments/index.js